import {
  PayloadAction,
  createAction,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

export type FeatureFlagType = {
  name: string;
  description: string;
  active: boolean;
};

type FeatureFlagsInitialState = {
  availableFeatureFlags: Record<string, FeatureFlagType>;
  loaded: boolean;
};

export const initialState: FeatureFlagsInitialState = {
  availableFeatureFlags: {},
  loaded: false,
};

export const featureFlagSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    getFeatureFlagSuccess: (
      state,
      action: PayloadAction<FeatureFlagType[]>,
    ) => {
      state.availableFeatureFlags = action.payload.reduce(
        (acc, featureFlag) => {
          acc[featureFlag.name] = featureFlag;
          return acc;
        },
        {} as Record<string, FeatureFlagType>,
      );
      state.loaded = true;
    },
  },
});

export const { getFeatureFlagSuccess } = featureFlagSlice.actions;

export const fetchFeatureFlags = createAction<void>(
  'featureFlags/fetchFeatureFlags',
);

export const featureFlagsSelectors = {
  isFlagActive: (state: RootState, flag: string) => {
    return state.featureFlag.availableFeatureFlags[flag]?.active ?? false;
  },
  selectAreAllFeatureFlagsFetched: (state: RootState, flags: string[]) => {
    return (
      Object.keys(state.featureFlag.availableFeatureFlags).length ===
      flags.length
    );
  },
};

export const selectAreAllFeatureFlagsFetched = createSelector(
  (state: RootState) => state.featureFlag.availableFeatureFlags,
  (_: RootState, flags: string[]) => flags,
  (availableFlags, flags) => {
    return Object.keys(availableFlags).length === flags.length;
  },
);

export default featureFlagSlice.reducer;
